export default {
  zh: {
    inviteRecord: '邀请记录',
    rewardDate: '奖励天数',
    friends: '好友',
    rules: '平台奖励规则'
  },
  en: {
    inviteRecord: 'Invitation records',
    rewardDate: 'Rewards',
    friends: 'Friends',
    rules: 'Reward Rules'
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliate/inviteRecord/lang.js